import { ApplePayService } from "./ApplePayService";
export class ApplePayServiceProvider {
    constructor(applePayService) {
        this.applePayService = applePayService;
    }
    static create(params) {
        return new ApplePayServiceProvider(ApplePayService.create(params));
    }
}
